import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-3" }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "password"
}, "Password", -1)
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "repeat_password"
}, "Repeat Password", -1)
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-primary"
}, "Update", -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("  ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputPassword = _resolveComponent("InputPassword")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    onSubmit: _ctx.onSubmit,
    "validation-schema": _ctx.validationSchema
  }, {
    default: _withCtx(({ isSubmitting, errors }) => [
      _createElementVNode("fieldset", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_InputPassword, {
            classNames: `form-control ${_ctx.isInvalid(errors, 'password')}`,
            id: "password",
            name: "password"
          }, null, 8, ["classNames"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_InputPassword, {
            classNames: `form-control ${_ctx.isInvalid(errors, 'repeat_password')}`,
            id: "repeat_password",
            name: "repeat_password"
          }, null, 8, ["classNames"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.errorMessage), 1))
            : _createCommentVNode("", true),
          (!isSubmitting)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _hoisted_10,
                (_ctx.shouldResetPassword === false)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-outline-primary",
                      onClick: _cache[0] || (_cache[0] = () => _ctx.$emit('onFinish', false))
                    }, " Cancel "))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["onSubmit", "validation-schema"]))
}